// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3":"b765ba7c","142":"b3889349","582":"e87ec785","588":"275a9129","727":"d4851621","803":"22696d5b","855":"1e3dcc3c","896":"8788e9ee"}[chunkId] + ".chunk.css";
};